'use strict'

var $ = window.jQuery;

function init() {
	var number = {
		item: $('.number'),
		start: parseInt($('.number--start').text()),
		end: parseInt($('.number--end').text())
	}
	if (number.item.length === 0) {
		return;
	}

	number.item.addClass('number--active');

	var updateText = function(value) {
		window.requestAnimationFrame(function() {
			number.item.text(numberWithCommas(Math.ceil(value)));
		});
	};

	$({someValue: number.start}).animate({someValue: number.end}, {
		duration: 3000,
		easing: 'linear',
		step: function() {
			updateText(this.someValue);
		},
		complete: function() {
			updateText(this.someValue);
		}
	});

};

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

var BookCounter = {
	init: init
};

module.exports = BookCounter;
